import styled from "@emotion/styled";

const MainOutlet = styled("main")(({ theme }) => ({
  marginLeft: "20px",
  padding: theme.spacing(0, 13),
  transition: "margin-left .2s ease-in-out",
  flex: 1,
  backgroundColor: theme.palette.grey[100],
  overflow: "auto",
  display: "flex",
  flexDirection: "column",
  scrollbarWidth: "thin",

  [theme.breakpoints.down("xl")]: {
    padding: theme.spacing(0, 6),
  },
  [theme.breakpoints.down("lg")]: {
    marginLeft: 0,
  },
}));

export default MainOutlet;
